import { Zap, Bot, Handshake, Music4 } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, Eyebrow, SectionShell } from "./Reveal";

const icons = [Zap, Bot, Handshake, Music4];

export default function Identity() {
  const { t } = useLang();

  return (
    <SectionShell id="identita" testid="identity-section" className="bg-white border-y border-slate-100">
      <Reveal className="text-center">
        <Eyebrow>{t.identity.eyebrow}</Eyebrow>
        <h2 className="mx-auto max-w-3xl font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
          {t.identity.title}
        </h2>
      </Reveal>

      <div className="mt-12 grid sm:grid-cols-2 gap-5">
        {t.identity.items.map((item, i) => {
          const Icon = icons[i];
          return (
            <Reveal key={item.t} delay={i * 0.08}>
              <div className="group h-full rounded-2xl border border-slate-200 bg-[#F8FAFC] p-6 sm:p-8 hover:bg-white hover:shadow-xl hover:shadow-sky-900/5 hover:-translate-y-1 transition-all duration-300">
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center h-12 w-12 rounded-2xl bg-sky-600/10 text-sky-600 group-hover:bg-sky-600 group-hover:text-white transition-colors">
                    <Icon size={22} />
                  </span>
                  <span className="font-mono text-3xl font-bold text-slate-200 group-hover:text-sky-200 transition-colors">
                    0{i + 1}
                  </span>
                </div>
                <p className="mt-5 text-sm sm:text-base text-slate-600 leading-relaxed">
                  <span className="font-mono font-bold text-slate-900 mr-2">{i + 1}.</span>
                  {item.d}
                </p>
              </div>
            </Reveal>
          );
        })}
      </div>

      <div className="mt-14 grid lg:grid-cols-2 gap-5">
        {[t.identity.finalita, t.identity.ambizioso].map((text, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div className="h-full rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
              <h3 className="font-display text-lg font-bold text-sky-700">
                {i === 0 ? t.identity.finalitaTitle : t.identity.ambiziosoTitle}
              </h3>
              <p className="mt-3 text-sm sm:text-base text-slate-600 leading-relaxed">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1} className="mt-10 text-center">
        <p className="mx-auto max-w-3xl font-serif-accent italic text-2xl sm:text-3xl text-slate-800 leading-snug">
          {t.identity.solo}
        </p>
      </Reveal>

      <Reveal delay={0.15} className="mt-10 text-center">
        <p className="mx-auto max-w-3xl font-display text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 leading-snug" data-testid="identity-represents">
          {t.identity.represents}
        </p>
        <p className="mx-auto mt-4 inline-flex items-center gap-2.5 rounded-full border border-amber-200 bg-amber-50 px-4 py-1.5 font-mono text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-amber-700">
          <span className="h-2 w-2 rounded-full bg-amber-500 animate-pulse" />
          {t.identity.battle}
        </p>
      </Reveal>

      <Reveal delay={0.15} className="mt-12">
        <div className="rounded-3xl border border-sky-100 bg-gradient-to-br from-sky-50 to-white p-6 sm:p-10">
          <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900 max-w-2xl">
            {t.identity.successTitle}
          </h3>
          <div className="mt-6 grid sm:grid-cols-2 gap-5">
            {t.identity.success.map((s, i) => (
              <div key={i} className="flex gap-4">
                <span className="font-mono font-bold text-amber-500">{i + 1}.</span>
                <p className="text-sm sm:text-base text-slate-600 leading-relaxed">{s}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </SectionShell>
  );
}
